import { imageAsset } from '@/data/sanity/fragments'
import cmsSettings from '../cmsSettings'

export const fields = `
  _type,
  _id,
  ${cmsSettings()},
  sectionBackground,
  title,
  items[] {
    ${imageAsset.fragment('image')},
    quote,
    authorName,
    authorRole
  }
`

export const fragment = (name = 'photoTextCarousel') => `${name}{ ${fields} }`

const exported = {
  fields,
  fragment,
}

export default exported
